import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/gdocnext_dev2/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/gdocnext_dev2/node_modules/next/dist/client/app-dir/link.js");
